import { render, staticRenderFns } from "./videojs.vue?vue&type=template&id=21cb4793&"
import script from "./videojs.vue?vue&type=script&lang=js&"
export * from "./videojs.vue?vue&type=script&lang=js&"
import style0 from "./videojs.vue?vue&type=style&index=0&id=21cb4793&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/Users/eralpsoftwareweb/Desktop/Active Projects/Heocademy/Gökçe Özel/gokce-ozel-nuxt/components/VideoPlayer/Video.vue').default})
